const islands = () => import('Views/mapData/islands');
const voyages = () => import('Views/mapData/voyages');
const satellites = () => import('Views/mapData/satellites');

export default[
  { path: '/map-data/islands', name: 'mapDataIslands', component: islands },
  { path: '/map-data/voyages', name: 'mapDataVoyages', component: voyages },
  { path: '/map-data/satellites', name: 'mapDataSatellites', component: satellites },
];



// WEBPACK FOOTER //
// ./src/router/mapData.js